import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Purchase from "./pages/Purchase";
import { NotFound } from "./pages/NotFound";
import { PurchaseProvider } from "./context/PurchaseContext";
import {
  BASE_URL,
  BUSINESS_URL,
  HOME_URL,
  PURCHASE_URL,
} from "./helpers/routes";

function App() {
  return (
    <BrowserRouter>
      <PurchaseProvider>
        <Routes>
          <Route path={BASE_URL} element={<Home />} />
          <Route
            path={HOME_URL}
            element={
              <PurchaseProvider>
                <Home />
              </PurchaseProvider>
            }
          />
          <Route path={`${BUSINESS_URL}/:businessId`} element={<Home />} />
          <Route
            path={`${BUSINESS_URL}/:businessId${PURCHASE_URL}/:planUuid`}
            element={<Purchase />}
          />
          <Route path={PURCHASE_URL} element={<Purchase />} />
          <Route path={`${PURCHASE_URL}/:planUuid`} element={<Purchase />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PurchaseProvider>
    </BrowserRouter>
  );
}

export default App;
